import ElementConstants from '../../../shared/constants/elements';

const ExtraBlocks = {
	TEXT_BOX: {
		type: ElementConstants.EXTRAS.TEXT_BOX,
		label: 'Text',
		icon: 'letters'
	}
	// HORIZONTAL_DIVIDER: {
	// 	type: ElementConstants.EXTRAS.HORIZONTAL_DIVIDER,
	// 	label: 'Insert Divider',
	// 	icon: 'text-width'
	// }
}

export default ExtraBlocks;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/blocks/extras.js